module.exports = __webpack_public_path__ + "static/assets/882f2ceb4ee5da69b7ed77410b735c25.png";